import fetch from "./fetch.js"
import axios from 'axios'

export default {
  GetStudentPosition(data) {
    return axios({
      url: `${window.RASESLHOSTA}/case2/Task/GetStudentPosition`,
      method: "post",
      data
    })
  },
  gettoken(data) { // 获取平台统一的token
    return fetch({
      url: `/skillscompetition/api/user/gettoken?id=${data.id}&loginType=0`,
      method: 'get',
    })
  },
  GetCurrentUserNewToken(data) { // 登录用户的获取新的token
    // axios.defaults.baseURL = window.CHANGEURLHOST
    // let obj = fetch({
    //     url: `/apiuser/ZdapSSO/GetCurrentUserNewToken`,
    //     method: 'get',
    // })
    // axios.defaults.baseURL = window.PUBLICHOSTA;
    // return obj;
    return fetch({
      url: '/skillscompetition/api/User/GetNewToken',
      method: 'get',
      data,
    })
  },
  loginIn(data) {
    return fetch({
      url: '/skillscompetition/api/user/practicelogin',
      method: 'post',
      data: {
        schoolId: 0,
        userName: data.userName,
        password: data.password
      }
    })
  },
  getbindingexamtagpositionlist(data) { //赛事岗位信息
    return fetch({
      url: `/skillscompetition/api/examliveapp/getbindingexamtagpositionlist?beforeTrainingId=${data.beforeTrainingId}`,
      method: 'get',
    })
  },
  addexamregist(data) { //提交报名
    return fetch({
      url: `/skillscompetition/api/signupschool/addexamregist`,
      method: 'post',
      data
    })
  },
  numberuserphoneauthentication(data) { //电话号码登陆
    return fetch({
      url: `/skillscompetition/api/authenticate/numberuserphoneauthentication?mb=${data.mb}&verificationCode=${data.verificationCode}&loginType=${data.loginType}`,
      method: 'get',
    })
  },
  verifyphonenumber(data) { //验证手机号码
    console.log(data);
    return fetch({
      url: `/skillscompetition/api/verificationcode/verifyphonenumber?mb=${data.phone}`,
      method: 'GET',
    })
  },
  checkverificationcode(data) { //校验手机验证码
    return fetch({
      url: `/skillscompetition/api/verificationcode/checkverificationcode?mb=${data.phone}&verificationCode=${data.verifyCode}`,
      method: 'GET',
    })
  },
  registeredusers(data) { //注册用户
    return fetch({
      // url: `/skillscompetition/api/verificationcode/registeredusers`,
      url: `/skillscompetition/api/authenticate/registeredusers`,
      method: 'post',
      data
    })
  },
  verifyroleactivationcode(data) { //验证角色激活码

    // axios.defaults.baseURL = window.CHANGEURLHOST
    let obj = fetch({
      // url: `/yssxs/ActivateSchool/VerifyRoleActCode?roleCode=${data.roleCode}&roleType=${data.roleType}`,
      url: `/skillscompetition/api/user/VerifyCode?code=${data.roleCode}&roleType=${data.roleType}&name=${data.name}&no=${data.no}`,
      // url: `/apiuser/Register/VerifyRoleActCode?roleCode=${data.roleCode}&roleType=${data.roleType}`,
      method: 'GET',
    });
    // axios.defaults.baseURL = window.PUBLICHOSTA;
    return obj

    // return fetch({
    //     url: `/skillscompetition/api/activateschool/verifyroleactivationcode?roleCode=${data.roleCode}&roleType=${data.roleType}`,
    //     method: 'GET',
    // })
  },
  fillinactivationinformation(data) { //填写激活信息
    // return fetch({
    //     url: `/skillscompetition/api/activateschool/fillinactivationinformation`,
    //     method: 'post',
    //     data
    // })
    axios.defaults.baseURL = window.CHANGEURLHOST
    let obj = fetch({
      url: `/yssxs/ActivateSchool/FillInActInformation`,
      method: 'POST',
      data,
    });
    axios.defaults.baseURL = window.PUBLICHOSTA;
    return obj;
    // return fetch({
    //     url: `/skillscompetition/api/activateschool/fillinactivationinformation`,
    //     method: 'post',
    //     data
    // })
  },
  UpdateUserPassword(data) { //专一网api--- 修改密码
    //修改密码
    axios.defaults.baseURL = window.CHANGEURLHOST
    let obj = fetch({
      url: `yssxs/User/UpdateUserPassword`,
      method: 'POST',
      data
    });
    axios.defaults.baseURL = window.PUBLICHOSTA;
    return obj;
  },

  CleanLoginCache(data) { // 激活用户后 清除用户的缓存信息
    return fetch({
      url: `/skillscompetition/api/User/CleanLoginCache?userId=${data.userId}`,
      method: 'get',
      data
    })
  },
  // 专一网 获取验证码
  getZYWVerifyCode(data) {
    axios.defaults.baseURL = window.CHANGEURLHOST
    let obj = fetch({
      url: `/yssxs/VerificationCode/GetVerifyCode`,
      method: 'get',
      params: data
    });
    axios.defaults.baseURL = window.PUBLICHOSTA;
    return obj;
    // return fetch({
    //   url: `/yssxs/VerificationCode/GetVerifyCode?phone=${data.phone}&verifyCode=${data.verifyCode}`,
    //   method: "get"
    // });
  },
  getverifycode(data) { //获取验证码
    return fetch({
      url: `/skillscompetition/api/verificationcode/getverifycode?phone=${data.phone}`,
      method: 'get',
      data
    })
  },
  bindphonebyuser(data) { //更换绑定手机
    return fetch({
      url: `/skillscompetition/api/skilluser/bindphonebyuser?mobilePhone=${data.mobilePhone}&verificationCode=${data.verificationCode}`,
      method: 'get',
      data
    })
  },
  // activationrecordinfo(data) { //查询用户激活信息
  //     return fetch({
  //         url: `/skillscompetition/api/activateschool/activationrecordinfo`,
  //         method: 'get',
  //         data
  //     })
  // },
  retrievepassword(data) { //找回密码
    return fetch({
      url: `/skillscompetition/api/authenticate/retrievepassword?mb=${data.mb}&verificationCode=${data.verificationCode}&password=${data.password}&againPassword=${data.againPassword}`,
      method: 'GET',
    })
  },
  getschoolcolleges(data) { //学校-院系 列表
    return fetch({
      url: `/skillscompetition/api/school/getschoolcolleges`,
      method: 'post',
      data
    })
  },
  getcollegeprofessions(data) { //获取 学校-院系-专业 列表
    return fetch({
      url: `/skillscompetition/api/school/getcollegeprofessions`,
      method: 'post',
      data
    })
  },
  getclasses(data) { //获取 学校-院系-专业-班级 列表
    return fetch({
      url: `/skillscompetition/api/school/getclasses`,
      method: 'post',
      data
    })
  },
  addupdateschoolcollege(data) { //添加 更新 院系
    return fetch({
      url: `/skillscompetition/api/school/addupdateschoolcollege`,
      method: 'post',
      data
    })
  },
  addupdatecollegeprofession(data) { //添加 更新 专业
    return fetch({
      url: `/skillscompetition/api/school/addupdatecollegeprofession`,
      method: 'post',
      data
    })
  },
  addupdateclass(data) { //添加 更新 班级
    return fetch({
      url: `/skillscompetition/api/school/addupdateclass`,
      method: 'post',
      data
    })
  },
  updateclass(data) { //修改班级
    return fetch({
      url: `/skillscompetition/api/skilluser/updateclass`,
      method: 'post',
      data
    })
  },
  getcurrentuserinfo(data) { //获取用户信息
    return fetch({
      url: `/skillscompetition/api/skilluser/getcurrentuserinfo`,
      method: 'get'
    })
  },
  changepassword(data) {
    return fetch({
      url: '/skillscompetition/api/skilluser/changepassword',
      method: 'post',
      data
    })
  },
  changeRealName(data) {
    return fetch({
      url: '/skillscompetition/api/user/setusername?realName=' + data.RealName + '&userId=' + data.id,
      method: 'get',
      data
    })
  },
  getliveappallinhome(data) { //登录首页获取赛事列表
    return fetch({
      url: `/skillscompetition/api/examliveapp/getliveappallinhome?taskUserType=0`,
      method: 'get'
    })
  },
  selfTrainingList(data) {
    return fetch({
      url: '/skillscompetition/api/studentexam/getpracticeexamlistbypage',
      method: 'post',
      data
    })
  },
  simulatedTrainingList(data) {
    return fetch({
      url: '/skillscompetition/api/studentexam/getemulationexamlistbypage',
      method: 'post',
      data
    })
  },
  topicList(data) { //获取试卷基本信息
    return fetch({
      url: `/skillscompetition/api/studentexam/getexampaperbasicinfo?examId=${data.ExamId}&gradeId=${data.GradeId}`,
      method: 'get',
    })
  },
  examBasicInfoView(data) { //获取试卷预览信息
    return fetch({
      url: `/skillscompetition/api/studentexam/getexampaperbasicinfoview?gradeId=${data.GradeId}`,
      method: 'get',
    })
  },
  topicDetail(data) { //获取题目详细信息
    return fetch({
      url: `/skillscompetition/api/studentexam/getquestioninfo?questionId=${data.QuestionId}&gradeId=${data.gradeId}`,
      method: 'get'
    })
  },
  getexamquestioninfoview(data) { //预览试卷详细信息
    return fetch({
      url: `/skillscompetition/api/studentexam/getexamquestioninfoview?questionId=${data.QuestionId}&examId=${data.examid}`,
      method: 'get'
    })
  },
  getexampaperinfoview(data) { //预览题目详细信息
    // console.log(data);
    return fetch({
      url: `/skillscompetition/api/studentexam/getexampaperinfoview?examId=${data.examid}`,
      method: 'get'
    })
  },
  topicDetailView(data) { //获取题目详细信息
    return fetch({
      url: `/skillscompetition/api/studentexam/getquestioninfoview?questionId=${data.QuestionId}&gradeId=${data.GradeId}`,
      method: 'get'
    })
  },
  submitExamAnswer(data) { //提交题目答案
    return fetch({
      url: '/skillscompetition/api/studentexam/submitanswer',
      method: 'post',
      data
    })
  },
  submitExam(data) { //提交试卷
    return fetch({
      url: `/skillscompetition/api/studentexam/submitexam?gradeId=${data}`,
      method: 'get'
    })
  },
  clearexamgradeinfo(data) {
    return fetch({
      url: `/skillscompetition/api/studentexam/clearexamgradeinfo?examId=${data.examId}`,
      method: 'get'
    })
  },
  ClearGradeInfo(data) {
    return fetch({
      url: `/skillscompetition/api/studentexam/ClearGradeInfo?gradeId=${data.gradeId}`,
      method: 'get'
    })
  },
  getconnectserverurl(data) { //获取服务器地址
    return fetch({
      url: `/skillscompetition/api/im/getconnectserverurl`,
      method: 'get'
    })
  },
  sendgroupmsg(data) { //向消息服务器发送信息
    return fetch({
      url: `/skillscompetition/api/im/sendgroupmsg`,
      method: 'post',
      timeout: 0,
      data
    })
  },
  joingroup(data) { //加入群聊
    return fetch({
      url: `/skillscompetition/api/im/joingroup?groupId=${data.groupId}`,
      method: 'GET',
    })

  },
  leavegroup(data) { //离开群聊
    return fetch({
      url: `/skillscompetition/api/im/leavegroup?groupId=${data.groupId}`,
      method: 'GET',
    })
  },
  getgroupmsghistory(data) { //获取聊天记录
    return fetch({
      url: `/skillscompetition/api/im/getgroupmsghistory`,
      method: 'post',
      data
    })
  },
  changeexamgroupposition(data) { //切换岗位
    return fetch({
      url: `/skillscompetition/api/exampapergroup/changeexamgroupposition?groupId=${data.groupId}&postionId=${data.postionId}`,
      method: 'GET',
    })
  },
  getexampapergrouplistbypage(data) { //获取分组列表
    return fetch({
      url: `/skillscompetition/api/exampapergroup/getexampapergrouplistbypage`,
      method: 'post',
      data
    })
  },
  getExamPaperPositions(data) { //获取考试岗位列表
    return fetch({
      url: `/skillscompetition/api/exampaper/getexampaperpostions?examId=${data.examId}`,
      method: 'get'
    })
  },
  createexamgroup(data) { //创建分组
    return fetch({
      url: `/skillscompetition/api/exampapergroup/createexamgroup`,
      method: 'post',
      data
    })
  },
  joinexamgroup(data) { //加入分组
    let url = data.password ? `/skillscompetition/api/exampapergroup/joinexamgroup?groupId=${data.groupId}&postionId=${data.postionId}&password=${data.password}` : `/skillscompetition/api/exampapergroup/joinexamgroup?groupId=${data.groupId}&postionId=${data.postionId}`
    return fetch({
      url: url,
      method: 'get',
    })
  },
  exitexamgroup(data) { //退出分组
    return fetch({
      url: `/skillscompetition/api/exampapergroup/exitexamgroup?groupId=${data.groupId}`,
      method: 'get'
    })
  },
  updatereadystatus(data) { //准备状态切换
    return fetch({
      url: `/skillscompetition/api/exampapergroup/updatereadystatus?groupId=${data.groupId}&IsReady=${data.IsReady}`,
      method: 'get'
    })
  },
  getparentlist(data) { // 加载模块列表
    return fetch({
      url: `/skillscompetition/api/bigdata/getparentlist?year=${data.year}`,
      method: 'get'
    })
  },
  getobjectlist(data) { // 加载大数据列表
    return fetch({
      url: `/skillscompetition/api/bigdata/getobjectlist?id=${data.id}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&year=${data.year}&parentId=${data.parentId}`,
      method: 'get',
    })
  },
  getdropdownlist(data) { // 搜索下拉列表
    return fetch({
      url: `/skillscompetition/api/bigdata/getdropdownlist?id=${data.id}`,
      method: 'get',
    })
  },
  getsearchlist(data) { // 搜索列表
    return fetch({
      url: `/skillscompetition/api/bigdata/getsearchlist`,
      method: 'post',
      data
    })
  },
  saveanswer(data) { // 一键复制
    return fetch({
      url: `/skillscompetition/api/bigdata/saveanswer`,
      method: 'post',
      data
    })
  },
  getsearchonditionslist(data) { //获取搜索条件下拉
    return fetch({
      url: `/skillscompetition/api/bigdata/getsearchonditionslist`,
      method: 'get',
    })
  },
  getcertificatesummerdatalist(data) { //查询总账
    return fetch({
      url: `/skillscompetition/api/certificate/getcertificatesummerdatalist?id=${data.id}&gradeId=${data.gradeId}&subjectType=${data.subjectType}&keyword=${data.keyword}&type=${data.type}`,
      method: 'get',
    })
  },
  getsubjectbytype(data) { //根据案例科目类型获取科目列表
    return fetch({
      url: `/skillscompetition/api/subject/getsubjectbytype?id=${data.id}&type=${data.type}`,
      method: 'get',
    })
  },
  getcertificatedetaildatalist(data) { //查询明细
    return fetch({
      url: `/skillscompetition/api/certificate/getcertificatedetaildatalist?id=${data.id}&gradeId=${data.gradeId}&subjectId=${data.subjectId}&type=${data.type}`,
      method: 'get',
    })
  },
  getcertificatebalancedatalist(data) { //查询科目余额表
    return fetch({
      url: `/skillscompetition/api/certificate/getcertificatebalancedatalist?id=${data.id}&gradeId=${data.gradeId}&subjectType=${data.subjectType}&keyword=${data.keyword}&type=${data.type}`,
      method: 'get',
    })
  },
  getstudentlastgrade(data) { //自主训练最近一次成绩统计
    return fetch({
      url: `/skillscompetition/api/studentreport/getstudentlastgrade?examId=${data.examId}`,
      method: 'get',
    })
  },
  getstudentgradelist(data) { //自主训练历史成绩统计
    return fetch({
      url: `/skillscompetition/api/studentreport/getstudentgradelist`,
      method: 'post',
      data
    })
  },
  getteamlastgrade(data) { //模拟训练最近一次团队成绩
    return fetch({
      url: `/skillscompetition/api/studentreport/getteamlastgrade?examId=${data.examId}`,
      method: 'get',
    })
  },
  getteamgradelist(data) { //模拟训练历史团队统计
    return fetch({
      url: `/skillscompetition/api/studentreport/getteamgradelist`,
      method: 'post',
      data
    })
  },
  geterrorquestionlist(data) { //错题分析(根据套题查询)
    return fetch({
      url: `/skillscompetition/api/studentreport/geterrorquestionlist?examId=${data.examId}`,
      method: 'get',
    })
  },
  getcase(data) { //大数据一键获取答案
    return fetch({
      url: `/skillscompetition/api/bigdata/getcase?examId=${data.examId}&gradeId=${data.gradeId}&questionId=${data.questionId}`,
      method: 'get',
    })
  },
  markquestion(data) { //标记题目
    return fetch({
      url: `/skillscompetition/api/studentexam/markquestion?gradeId=${data.gradeId}&questionId=${data.questionId}`,
      method: 'get',
    })
  },
  ecxelexport(data) { //大数据excel导出
    return fetch({
      url: `skillscompetition/api/bigdata/ecxelexport`,
      method: 'post',
      data
    })
  },
  getexamschoolcompetitiontasklist(data) { //获取校内赛任务列表
    return fetch({
      url: '/skillscompetition/api/examschoolcompetitiontask/getexamschoolcompetitiontasklist',
      method: 'post',
      timeout: 0,
      data
    })
  },
  verifypassword(data) { //验证密码
    return fetch({
      url: `/skillscompetition/api/examschoolcompetitiontask/verifypassword`,
      method: 'post',
      data
    })
  },
  saveexamschoolcompetitiontask(data) { //保存校内赛任务
    return fetch({
      url: '/skillscompetition/api/examschoolcompetitiontask/saveexamschoolcompetitiontask',
      method: 'post',
      timeout: 0,
      data
    })
  },
  getavailablecaselist(data) { //获取学校可用案例
    return fetch({
      url: `/skillscompetition/api/examschoolcompetitiontask/getavailablecaselist?competitionType=${data.competitionType}`,
      method: 'get',
      timeout: 0,
      data
    })
  },
  deleteexamschoolcompetitiontask(data) { //删除校内赛任务
    return fetch({
      url: `/skillscompetition/api/examschoolcompetitiontask/deleteexamschoolcompetitiontask?id=${data.id}`,
      method: 'get',
      data
    })
  },
  publishschoolcompetitiontask(data) { //发布校内赛任务
    return fetch({
      url: `/skillscompetition/api/examschoolcompetitiontask/publishschoolcompetitiontask?id=${data.id}`,
      method: 'get',
      data
    })
  },
  validateprocompetitiondate(data) { //校内赛验证是否在考试时间
    return fetch({
      url: `/skillscompetition/api/examschoolcompetitiontask/validateschoolcompetitiondate?venuesId=${data.venuesId}`,
      method: 'get',
      timeout: 0
    })
  },
  //获取科目
  getSubject(data) {
    return fetch({
      url: `/skillscompetition/api/subject/getsubjectbytype?id=${data}&type=0`,
      method: 'get'
    })
  },
  //获取摘要
  getDigest(data) {
    return fetch({
      url: `/skillscompetition/api/summary/getsummarylist?id=${data}`,
      method: 'get'
    })
  },
  // 教师
  //获取自主练习试卷列表
  papercenterlistbypage(data) {
    return fetch({
      url: '/skillscompetition/api/teacherexam/getpapercenterlistbypage',
      method: 'post',
      timeout: 0,
      data
    })
  },
  // 开启试卷
  opencasebyschool(data) {
    console.log(data)
    return fetch({
      url: `/skillscompetition/api/teacherexam/opencasebyschool?caseId=${data.caseId}`,
      method: 'get'
    })
  },
  // 新增/修改申请订单
  savecaseapply(data) {
    return fetch({
      url: '/skillscompetition/api/schoolcase/savecaseapply',
      method: 'post',
      timeout: 0,
      data
    })
  },
  getcompetitionmonitor(data) { // - 实时监控-团队
    return fetch({
      url: `/skillscompetition/api/schoolcompetitionreport/getcompetitionmonitor?taskId=${data.taskId}`,
      method: 'get',
    })
  },
  getindividualcompetitionmonitor(data) { // - 实时监控-个人
    return fetch({
      url: `/skillscompetition/api/schoolcompetitionreport/getindividualcompetitionmonitor?taskId=${data.taskId}`,
      method: 'get',
    })
  },

  getcompetitionrank(data) { //总分排名-团队
    return fetch({
      url: `/skillscompetition/api/schoolcompetitionreport/getcompetitionrank?taskId=${data.taskId}`,
      method: 'get',
      timeout: 0,
    })
  },

  getcompetitiondetailrank(data) { //成绩明细-团队
    return fetch({
      url: `/skillscompetition/api/schoolcompetitionreport/getcompetitiondetailrank`,
      method: 'post',
      data
    })
  },
  getindividualcompetitionrank(data) { //总分排名-个人
    return fetch({
      url: `/skillscompetition/api/schoolcompetitionreport/getindividualcompetitionrank?taskId=${data.taskId}`,
      method: 'get'
    })
  },
  getindividualcompetitiondetailrank(data) { //成绩明细-个人
    return fetch({
      url: `/skillscompetition/api/schoolcompetitionreport/getindividualcompetitiondetailrank`,
      method: 'post',
      data
    })
  },
  practiceerroranalysis(data) { //教师 自主分析-错题分析
    return fetch({
      url: `/skillscompetition/api/teacherexam/examerroranalysis`,
      method: 'post',
      data
    })
  },
  getshoolcompetitioncaselist(data) { //获取校园赛可购买案例
    return fetch({
      url: `/skillscompetition/api/examschoolcompetitiontask/getshoolcompetitioncaselist`,
      method: 'get',
      timeout: 0,
    })
  },
  practicepersonalanalysis(data) { //自主分析 - 个人练习分析
    return fetch({
      url: `/skillscompetition/api/teacherexam/practicepersonalanalysis`,
      method: 'get',
      timeout: 0,
    })
  },
  exportpracticepersonaldetail(data) { //自主分析 - 个人练习分析-导出
    return fetch({
      url: `/skillscompetition/api/teacherexam/exportpracticepersonaldetail?ExamId=${data.ExamId}`,
      method: 'get',
    })
  },

  practicepersonaldetail(data) { //自主分析 - 个人练习分析 - 明细
    return fetch({
      url: `/skillscompetition/api/teacherexam/practicepersonaldetail`,
      method: 'post',
      data
    })
  },
  emulationteamanalysis(data) { //模拟分析 - 团队练习分析
    return fetch({
      url: `/skillscompetition/api/teacherexam/emulationteamanalysis`,
      method: 'get',
      // timeout:0,
    })
  },
  emulationteamanalysisdetail(data) { // -模拟分析 - 团队练习分析 - 明细
    return fetch({
      url: `/skillscompetition/api/teacherexam/emulationteamanalysisdetail`,
      method: 'post',
      // timeout:0,
      data
    })
  },
  examerroranalysisdetail(data) { //自主分析 - 个人练习分析-导出
    return fetch({
      url: `/skillscompetition/api/teacherexam/examerroranalysisdetail?examId=${data.examId}`,
      method: 'get',
    })
  },
  emulationpersonalanalysisdetail(data) { // -模拟分析 - 个人练习分析 - 明细
    return fetch({
      url: `/skillscompetition/api/teacherexam/emulationpersonalanalysisdetail`,
      method: 'post',
      // timeout:0,
      data
    })
  },
  getexampaperpostions(data) { //模拟分析 - 个人练习分析-岗位获取
    return fetch({
      url: `/skillscompetition/api/exampaper/getexampaperpostions?examId=${data.examId}`,
      method: 'get',
    })
  },
  emulationpersonalanalysis(data) { //模拟分析 - 个人练习分析-折线图
    return fetch({
      url: `/skillscompetition/api/teacherexam/emulationpersonalanalysis?examId=${data.examId}`,
      method: 'get',
    })
  },
  GetPythonToken(data) {
    return fetch({ //获取 Python接口Token
      url: `/skillscompetition/api/topic/getpythontoken`,
      method: 'get',
      data
    })
  },
  getuserintegral(data) {
    return fetch({ //获取 积分
      url: `/skillscompetition/api/user/getuserintegral?userId=${data.userId}`,
      method: 'get',
      data
    })
  },
  getsystemnoticelisthome(data) {
    return fetch({ //公告
      url: `/skillscompetition/api/systemnotice/getsystemnoticelisthome`,
      method: 'get',
      data
    })
  },
  GetVerifyCodeResetPassword(data) {
    axios.defaults.baseURL = window.PUBLICHOSTAA;
    return axios({ 
      url: `/yssxs/VerificationCode/GetVerifyCode?phone=${data.phone}&type=${data.type}&verifyCode=${data.verifyCode}`,
      method: 'get',
      headers:{
        'Authorization':`${data.Authorization}`
      }
    })
  },
  RetrievePassword(data) {
    console.log('666',data);
    axios.defaults.baseURL = window.PUBLICHOSTAA;
    return axios({ 
      url: `/yssxs/OAuth/RetrievePassword?mb=${data.mb}&verificationCode=${data.verificationCode}&password=${data.password}&againPassword=${data.againPassword}`,
      method: 'get',
      headers:{
        'Authorization':`${data.Authorization}`
      }
    })
  },
  GetExperienceToken(data) {
    axios.defaults.baseURL = window.PUBLICHOSTAA;
    return axios({ 
      url: `/apiuser/ZdapSSO/GetExperienceToken?loginType=3`,
      method: 'get',
      data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/login.js